// components/landing/sections/TrustedBy.tsx
// Partner/funder logo bar with grayscale → color on hover.

import { Box, Typography, alpha, useTheme } from "@mui/material";

interface Partner {
  src: string;
  alt: string;
  height: number;
}

const PARTNERS: Partner[] = [
  { src: "/images/partners/clinic_barcelona.png", alt: "Hospital Clinic Barcelona", height: 50 },
  { src: "/images/partners/eu_funded.png", alt: "Funded by the European Union", height: 44 },
  { src: "/images/partners/vhio_logo.png", alt: "VHIO", height: 48 },
  { src: "/images/partners/microsoft_startups.png", alt: "Microsoft for Startups", height: 40 },
];

export default function TrustedBy() {
  const theme = useTheme();

  return (
    <Box
      id="team"
      sx={{
        py: { xs: 5, md: 7 },
        px: 4,
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
      }}
    >
      <Typography
        variant="overline"
        sx={{
          display: "block",
          textAlign: "center",
          letterSpacing: 3,
          color: alpha(theme.palette.common.white, 0.5),
          mb: 4,
          fontSize: "0.75rem",
        }}
      >
        SUPPORTED BY
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: 4, md: 8 },
          flexWrap: "wrap",
        }}
      >
        {PARTNERS.map((partner) => (
          <Box
            key={partner.alt}
            sx={{
              filter: "brightness(0) invert(1) opacity(0.55)",
              transition: "filter 0.3s ease, transform 0.3s ease",
              "&:hover": {
                filter: "brightness(0) invert(1) opacity(1)",
                transform: "scale(1.05)",
              },
            }}
          >
            <img
              src={partner.src}
              alt={partner.alt}
              style={{
                height: partner.height,
                width: "auto",
                display: "block",
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
